<template>
    <div class="main">
        <!-- 情報站標題 -->
        <div class="main-title">
            <b-row align-h="between">
                <b-col cols="auto"><h2 class="px-3">智慧農場</h2></b-col>
                <b-col cols="auto" align-self="center"><b-breadcrumb :items="items"></b-breadcrumb></b-col>
            </b-row>
        </div>
        <div class="main-content">
            <div class="agri-result-group">
                <b-container>
                    <h3>智慧農場</h3>
                    <b-row cols="1" class="py-3">
                        <carousel :autoplay="true" :margin="10" :loop="true" :nav="false" :dots="false" :responsive="{0:{items: 1},768:{items: 2},992:{items: 4}}" v-if="farmData">
                        <b-col v-for="(data, index) in farmData" :key="index">
                            <b-link :to="data.url" class="agri-result-item drop-shadow">
                                <div class="agri-result-pic">
                                    <b-img :src="data.src"  fluid></b-img>
                                </div>
                                <div class="agri-result-info">
                                    <h3 class="agri-result-title">{{ data.title }}</h3>
                                </div>
                            </b-link>
                        </b-col>
                    </carousel>
                    </b-row>
                </b-container>
            </div>
            <!-- 先前隱藏 -->
            <div class="sub-content py-3">
                <b-container v-show="detailShow.length > 0">
                    <h3>智慧農業成果</h3>
                    <b-row cols="1" cols-md="2" cols-lg="3" class="smartFarm-result-group" align-h="center" style="display: none;">
                        <b-col>
                            <div class="smartFarm-result-item cases">
                                <b-row cols="2" cols-md="2" align-h="end">
                                    <b-col>
                                        <div class="smartFarm-result-title">{{resultData1.title}}</div>
                                        <div><span class="smartFarm-num">{{resultData1.num}}</span><span>{{resultData1.type}}</span></div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="smartFarm-result-item crops">
                                <b-row cols="2" cols-md="2" align-h="end">
                                    <b-col>
                                        <div class="smartFarm-result-title">{{resultData2.title}}</div>
                                        <div><span class="smartFarm-num">{{resultData2.num}}</span><span>{{resultData2.type}}</span></div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col>
                            <div class="smartFarm-result-item area">
                                <b-row cols="2" cols-md="2" align-h="end">
                                    <b-col>
                                        <div class="smartFarm-result-title">{{resultData3.title}}</div>
                                        <div><span class="smartFarm-num">{{resultData3.num}}</span><span>{{resultData3.type}}</span></div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="py-5" align-h="center" style="display: none;">
                        <b-col cols="auto">
                            <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref">行政區</label>
                                <b-form-select id="inline-form-custom-select-pref" class="mb-2 mr-sm-2 mb-sm-0"
                                v-model="selectCity" :options="cityList" :value="selectCity" value-field="value" text-field="text"></b-form-select>
                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row cols="1" cols-md="2" cols-lg="3" class="agri-result-group pb-3">
                        <b-col v-for="(item, index) in detailShow" :key="index">
                            <div class="agri-result-item drop-shadow">
                                <div class="agri-result-areapic">
                                    <b-img :src="item.src" fluid></b-img>
                                </div>
                                <div class="agri-result-info">
                                    <h3 class="agri-result-title">{{item.title}}</h3>
                                    <div class="agri-result-content-farm">
                                        <!--
                                        <div class="list-inline">
                                            <div class="list-inline-item pr-2"><b-badge variant="primary">建置年度</b-badge>{{ item.year }}年
                                            </div>
                                            <div class="list-inline-item"><b-badge variant="primary">成果效益</b-badge>省工：{{ item.benefit }}%
                                            </div>
                                        </div>
                                        <div><b-badge variant="primary">解決目標</b-badge>{{ item.target }}</div>
                                        <div class="farm-detail"><b-badge variant="primary">解決策略</b-badge>{{ item.strategy }}
                                        </div>
                                        -->
                                        <div class="unit-introduction">
                                            <b-badge variant="primary">單位介紹</b-badge>{{ item.unit_introduction }}
                                        </div>
                                        <div class="achievement-introduction">
                                            <b-badge variant="primary">成果介紹</b-badge>{{ item.achievement_introduction }}
                                        </div>
                                    </div>
                                    <p><button type="button" class="btn btn-primary btn-block" @click="openAlbum(index)">查看更多相片</button></p>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
            <!-- 先前隱藏 -->
        </div>

        <!-- 彈出視窗(相簿) -->
        <div v-show="modal.album.show" class="w3-modal" style="display: block;background:#000000DD;">
            <div class="w3-content w3-display-container">

                <div class="w3-display-container mySlides">
                    <img id="modal.album.url" src="" style="width:100%;">
                </div>

                <div class="w3-button w3-display-topleft w3-text-white" style="background:#000000AA;">{{ modal.album.index+1 }}/{{ modal.album.list.length }}</div>

                <div @click="modal.album.show = false" class="w3-button w3-display-topright w3-text-white" style="background:#000000AA;">X</div>
                <div @click="previousAlbum()" class="w3-button w3-display-left w3-text-white" style="background:#000000AA;">&#10094;</div>
                <div @click="nextAlbum()" class="w3-button w3-display-right w3-text-white" style="background:#000000AA;">&#10095;</div>
                
                <div class="w3-center w3-container w3-large w3-text-white w3-display-bottommiddle" style="width:100%;background: #000000AA;padding-top: 5px;padding-bottom: 5px;">
                    <template v-for="(data, index) in modal.album.list" >
                        <span class="w3-badge demo w3-border w3-transparent w3-hover-white" :class="modal.album.index == index ? 'w3-white' : '' " :key="index" @click="goAlbum(index);"></span>
                    </template>    
                </div>

            </div>
        </div>  
    </div>
</template>

<script>
export default {
    data() {
        return {

            //彈出視窗
            modal:{           
                //相簿(智慧農場專用)
                album:{
                    //是否呈現
                    show:false,
                    //標題
                    title:" 近9日均價及成交量",
                    //清單
                    list:[],
                    //位置
                    index:0,
                    //識別碼
                    sn:"",
                    //網址
                    src:""
                },
            },
            items: [
                {
                    text: '首頁',
                    href: '#/'
                },
                {
                    text: '智慧農場',
                    active: true
                }
            ],
            selectCity: "all",
            farmData: null,
            resultData1: {title:"", num:"", type:""},
            resultData2: {title:"", num:"", type:""},
            resultData3: {title:"", num:"", type:""},
            cityList: null,
            detailAll: null,
            detailShow: null,
            apiGetFarmData: (data) => // 智慧農業
                this.userRequest.get("../static/json/smartfarm.json", data),
            //api 取得智慧農場
            apiGetWisdomFarm: (data) => this.userRequest.post("/API/Default/GetWisdomFarm", data),   
            //api 取得智慧農業成果
            apiGetWisdomAgriResult: (data) => this.userRequest.post("/API/Default/GetWisdomAgriResult", data),   
        }
    },
    components: {
    },
    updated() {
    },
    mounted() {
        this.FunctionToken(this.getData, {});
        this.getGetWisdomFarm();
        this.getWisdomAgriResult();
    },
    methods: {
        getData(data) {
            this.apiGetFarmData(data)
                .then((res) => {
                    const json = res.data;
                    console.log(json)
                    //this.farmData = json.farmData; // 智慧農業成果
                    // 智慧農業成果
                    //this.resultData1 = {title:json.resultData[0].title, num:json.resultData[0].num, type:json.resultData[0].type}; 
                    //this.resultData2 = {title:json.resultData[1].title, num:json.resultData[1].num, type:json.resultData[1].type};
                    //this.resultData3 = {title:json.resultData[2].title, num:json.resultData[2].num, type:json.resultData[2].type};
                    // console.log(this.resultData1,this.resultData2,this.resultData3);
                    //this.cityList = json.cityList; // 行政區
                    //this.detailAll = json.detailList; // 行政區-Detail
                    this.detailShow = []; // 行政區-Detail
                    this.setCity("all" );
                    // console.log(this.detailShow);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        setCity(data) {
            // console.log('setCity=',data,this.selectCity);
            this.selectCity = data
            this.detailShow = []; // 行政區-Detail
            for (let i = 0; i < this.detailAll.length; i++) {
                if (data == "all" || data == this.detailAll[i].city)
                {
                    this.detailShow.push(this.detailAll[i]);
                }
            }
            // console.log('City=',this.detailShow);
        },
        //取得智慧農場
        getGetWisdomFarm:function()
        {
            this.soil = [];

            this.apiGetWisdomFarm({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                const list = data.list;
                this.farmData = [];
                for(var i=0;i < list.length ; i++){

                    var item = list[i];
                    this.farmData.push({
                        title:item.name,
                        src:'https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_farm/' + item.sn + '/' + item.cover,
                        url:'FarmDetail_new/' + item.sn
                    });
                    console.log(item.name);
                }

            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });

        },

        //取得智慧農業成果
        getWisdomAgriResult:function()
        {
            this.apiGetWisdomAgriResult({

            })
            .then((res)=>{

                const data = JSON.parse(res.data);
                const list = data.list; 
                const town = data.town; 
                const total = data.total;

                this.detailAll = [];
                this.cityList = [];

                for(var i=0; i<list.length ; i++)
                {
                    var item = list[i];

                    this.detailAll.push({

                        src:"https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/" + item.sn + "/" + item.cover,
                        sn:item.sn,
                        title:item.name,
                        year:item.year,
                        benefit:item.save_labour,
                        target:item.question,
                        strategy:item.solution,
                        city:item.town,
                        unit_introduction:item.unit_introduction,
                        achievement_introduction:item.achievement_introduction,
                        photo:item.photo,
                    });
                }

                this.cityList.push({

                    text:"全部的行政區",
                    value: "all"
                });

                for(var i2=0; i2<town.length ; i2++)
                {
                    var item2 = town[i2];
                    this.cityList.push({

                        text:item2,
                        value:item2
                    });
                }

                this.setCity("all" );

                this.resultData1 = {title:total.case.title, num:total.case.value, type:total.case.unit}; 
                this.resultData2 = {title:total.crop.title, num:total.crop.value, type:total.crop.unit}; 
                this.resultData3 = {title:total.area.title, num:total.area.value, type:total.area.unit}; 



            })
            .catch((err)=> {
                console.log(err);
                this.disableMask();
            });
        },

        //開啟相簿
        openAlbum:function(index) 
        {    
            this.modal.album.index = 0;
            this.modal.album.sn = this.detailShow[index].sn;
            this.modal.album.list = this.detailShow[index].photo;
            this.modal.album.url = "https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/" + this.modal.album.sn +"/" + this.modal.album.list[this.modal.album.index].src;
            document.getElementById("modal.album.url").src = this.modal.album.url;
            this.modal.album.show = true;
        },
        //相簿(上一筆)
        previousAlbum:function() 
        {    
            this.modal.album.index -= 1;
            if(this.modal.album.index < 0)
            {
                this.modal.album.index = this.modal.album.list.length-1;
            }
            this.modal.album.url = "https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/" + this.modal.album.sn +"/" + this.modal.album.list[this.modal.album.index].src;   
            document.getElementById("modal.album.url").src = this.modal.album.url;
        },
        //相簿(下一筆)
        nextAlbum:function() 
        {    
            this.modal.album.index += 1;
            if(this.modal.album.index >= this.modal.album.list.length)
            {
                this.modal.album.index = 0;
            }
            this.modal.album.url = "https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/" + this.modal.album.sn +"/" + this.modal.album.list[this.modal.album.index].src;
            document.getElementById("modal.album.url").src = this.modal.album.url;
        },
        //相簿(前去該筆)
        goAlbum:function(index) 
        {    
            this.modal.album.index = index;
            this.modal.album.url = "https://agri-data.kcg.gov.tw/assets/img/yun_lin/wisdom_agri_result/" + this.modal.album.sn +"/" + this.modal.album.list[this.modal.album.index].src;
            document.getElementById("modal.album.url").src = this.modal.album.url;
        },
    },
    watch: {
        selectCity: function(newValue){
            // console.log('selectCity=',newValue,this.selectCity);
            this.setCity(newValue);
        }
    }
}
</script>
<style>
    .w3-left, .w3-right, .w3-badge {cursor:pointer}
    .w3-badge {
        height:18px;
        width:18px;
        padding:0;
        margin-left: 5px;
        margin-right: 5px;    
    }
</style>
